import { useLang } from '@/i18n';
import EcoImg from 'eco-design-components/base/eco-img';
import EcoSpace from 'eco-design-components/base/eco-space';
import css from './index.module.scss';
import { useRouter } from 'next/router';

const N: React.FC = () => {
    const { t } = useLang('rapidpro');
    const { locale = 'jp' } = useRouter();
    const IS_JP = locale === 'jp';
    const imgs: any = {
        en: ['https://websiteoss.ecoflow.com/upload/image/1749019760018/15.jpg', 'https://websiteoss.ecoflow.com/upload/image/1749019774120/15_M.jpg'],
        jp: ['https://websiteoss.ecoflow.com/upload/image/1749519899218/15_jp.jpg', 'https://websiteoss.ecoflow.com/upload/image/1749519899026/15_jp_M.jpg'],
    };
    const img = imgs[locale] || imgs.en;

    return (
        <div id="rapid-pro-N" className={`rapid-pro-N ${css.section} GtmModuleData-section`} data-section-id={'rapid-pro-N'} data-section-title={t('N_title')}>
            {!IS_JP && <EcoSpace />}
            <div className="media">
                <EcoImg pc={img[0]} pad={img[0]} h5={img[1]} />
                {!IS_JP && (
                    <div className="info">
                        <p className="info-title">{t('N_title')}</p>
                        <p className="info-desc">{t('N_desc')}</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default N;
